import * as _ from 'underscore';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DashboardDataService, ICustomerDashboardInfo } from '../../../../shared/report/dashboard-data.service';
import { urlUtil } from '../../../../shared/util';
import { IObject } from '../../../../../type_definitions/datatypes';
import { AuthService } from '../../../../shared/services/auth/auth.service';
import { IRoleContact } from '../../../webshop/info/webshop-info-data.service';

import { RoleContactType } from '../../../../shared/contact/role-contact-type';
import { URL_WEBSHOP_CHECKLIST } from '../../../../shared/browser/url-collections';

interface IGroupedRoleContacts {
  contactType:RoleContactType;
  roleContacts:IRoleContact[];
}

export const FILTER_CHANGE_DEBOUNCE_TIME:number = 250;

@Component({
  selector: 'customer-dashboard-subtitle',
  template: `
    <div *ngIf="!loading">
      <!-- display customer logo -->
      <a *ngIf="webshopChecklistUrl && logoUrl" [href]="webshopChecklistUrl" target="_blank">
        <img [src]="logoUrl" alt="" />
      </a>
      <img *ngIf="!webshopChecklistUrl && logoUrl" [src]="logoUrl" alt="" />
      
      <!-- display role contacts -->
      <div class="customer-contacts" *ngIf="groupedRoleContacts?.length">
        <ng-container *ngFor="let groupRoleContacts of groupedRoleContacts; trackById">
          <div>
            <span class="bold">{{ groupRoleContacts.contactType }}</span>:
            <ng-container *ngFor="let roleContact of groupRoleContacts.roleContacts; trackById">
              <contact-info [roleContact]="roleContact" showContactOnly="true"></contact-info>
            </ng-container>
          </div>
        </ng-container>

        <!-- display focus contact -->
        <div *ngIf="focusContacts">
          <span class="bold" translate>GA.CONTACT_INFO.FOCUS_CONTACT</span>:
          <ng-container *ngFor="let roleContact of focusContacts; trackById">
            <contact-info [roleContact]="roleContact" showContactOnly="true"></contact-info>
          </ng-container>
        </div>
      </div>
    </div>
    <activity-indicator *ngIf="loading"></activity-indicator>
  `
})
export class CustomerDashboardSubtitleComponent implements OnChanges {
  @Input() public filters:IObject;
  public loading:boolean;
  public webshopChecklistUrl:string;
  public logoUrl:string;
  public groupedRoleContacts:IGroupedRoleContacts[];
  public focusContacts:IRoleContact[];
  private filtersChangeDebounceTimer:NodeJS.Timeout;

  constructor(
    private dashboardDataService:DashboardDataService,
    private authService:AuthService
  ) {
    /***/
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes.filters) {
      this.filters = changes.filters.currentValue;

      // add debounce for triggering the customer dashboard due to rapid and repetitive filter changes (customer user)
      clearTimeout(this.filtersChangeDebounceTimer);
      this.filtersChangeDebounceTimer = setTimeout(this.onFiltersChanged, FILTER_CHANGE_DEBOUNCE_TIME);
    }
  }

  private onFiltersChanged = ():void => {
    const webshopId:number = this.filters?.customer?.id;
    const companyId:number = this.filters?.customerCompany?.id;


    if(webshopId || companyId) {
      this.loading = true;
      this.dashboardDataService.customerDashboardInfo(webshopId, companyId)
        .then((customerInfo:ICustomerDashboardInfo) => {
          this.webshopChecklistUrl = !this.authService.checkCustomersUser() && customerInfo?.webshopId ? urlUtil.replaceParams(URL_WEBSHOP_CHECKLIST, { webshopId: customerInfo.webshopId }) : undefined;
          this.logoUrl = customerInfo?.logo;
          this.groupRoleContacts(customerInfo?.roleContacts);
          if(this.authService.checkAcslUser()){
            this.focusContacts = _.findWhere(this.groupedRoleContacts, { contactType: customerInfo?.focusContactType?.id })?.roleContacts;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      this.webshopChecklistUrl = undefined;
      this.logoUrl = undefined;
      this.groupedRoleContacts = undefined;
      this.focusContacts = undefined;
    }
  };

  // this method groups roleContacts based on contactType
  private groupRoleContacts(roleContacts:IRoleContact[]):void {
    this.groupedRoleContacts = [];
    _.each(roleContacts, (roleContact:IRoleContact) => {
      if(roleContact.contactType) {
        const groupIdx:number = _.findIndex(this.groupedRoleContacts, { contactType: roleContact.contactType });
        if (groupIdx === -1) {
          // create roleContact to a new group
          this.groupedRoleContacts.push({
            contactType: roleContact.contactType,
            roleContacts: [ roleContact ]
          });
        } else {
          // add roleContact to an existing group
          this.groupedRoleContacts[ groupIdx ].roleContacts.push(roleContact);
        }
      }
    });
  }
}